import Footer from "components/Footer";
import Header from "components/Header";
import { useEffect } from "react";

type MainLayoutProps = {
  headerShow?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
};

export const withMainLayout =
  (WrapperComponent: any, layoutProps?: MainLayoutProps) => (props: any) => {
    useEffect(() => {
      window.scrollTo({ behavior: "smooth", top: 0 });
    }, []);

    const shouldRenderHeader = !layoutProps?.hideHeader;
    const shouldRenderFooter = !layoutProps?.hideFooter;

    return (
      <>
        {shouldRenderHeader && (
          <Header show={layoutProps?.headerShow} />
        )}
        <WrapperComponent {...props} />
        {shouldRenderFooter && <Footer />}
      </>
    );
  };
